module.exports = __webpack_public_path__ + "static/23-7c0bc3cb14b2f581c19546a385c981d2.jpg";